//
// WARNING: this file was auto-generated by @phensley/cldr-compiler. DO NOT EDIT.
//
export var cardinalRules = {
    af: [[1, [[0]]]],
    ak: [[1, [[1]]]],
    am: [[1, [[2], [0]]]],
    an: [[1, [[0]]]],
    ar: [
        [0, [[3]]],
        [1, [[0]]],
        [2, [[4]]],
        [3, [[5]]],
        [4, [[6]]]
    ],
    ars: [
        [0, [[3]]],
        [1, [[0]]],
        [2, [[4]]],
        [3, [[5]]],
        [4, [[6]]]
    ],
    as: [[1, [[2], [0]]]],
    asa: [[1, [[0]]]],
    ast: [[1, [[7, 8]]]],
    az: [[1, [[0]]]],
    bal: [[1, [[0]]]],
    be: [
        [1, [[9, 10]]],
        [3, [[11, 12]]],
        [4, [[13], [14], [15]]]
    ],
    bem: [[1, [[0]]]],
    bez: [[1, [[0]]]],
    bg: [[1, [[0]]]],
    bho: [[1, [[1]]]],
    blo: [
        [0, [[3]]],
        [1, [[0]]]
    ],
    bm: [],
    bn: [[1, [[2], [0]]]],
    bo: [],
    br: [
        [1, [[9, 16]]],
        [2, [[17, 18]]],
        [3, [[19, 20]]],
        [4, [[21, 22]]]
    ],
    brx: [[1, [[0]]]],
    bs: [
        [
            1,
            [
                [8, 23, 24],
                [25, 26]
            ]
        ],
        [
            3,
            [
                [8, 27, 28],
                [29, 30]
            ]
        ]
    ],
    ca: [
        [1, [[7, 8]]],
        [4, [[31, 32, 33, 8], [34]]]
    ],
    ce: [[1, [[0]]]],
    ceb: [
        [
            1,
            [
                [8, 35],
                [8, 36],
                [37, 38]
            ]
        ]
    ],
    cgg: [[1, [[0]]]],
    chr: [[1, [[0]]]],
    ckb: [[1, [[0]]]],
    cs: [
        [1, [[7, 8]]],
        [3, [[39, 8]]],
        [4, [[37]]]
    ],
    csw: [[1, [[1]]]],
    cv: [
        [0, [[3]]],
        [1, [[0]]]
    ],
    cy: [
        [0, [[3]]],
        [1, [[0]]],
        [2, [[4]]],
        [3, [[40]]],
        [4, [[41]]]
    ],
    da: [[1, [[0], [42, 43]]]],
    de: [[1, [[7, 8]]]],
    doi: [[1, [[2], [0]]]],
    dsb: [
        [1, [[8, 44], [45]]],
        [2, [[8, 46], [47]]],
        [3, [[8, 48], [49]]]
    ],
    dv: [[1, [[0]]]],
    dz: [],
    ee: [[1, [[0]]]],
    el: [[1, [[0]]]],
    en: [[1, [[7, 8]]]],
    eo: [[1, [[0]]]],
    es: [
        [1, [[0]]],
        [4, [[31, 32, 33, 8], [34]]]
    ],
    et: [[1, [[7, 8]]]],
    eu: [[1, [[0]]]],
    fa: [[1, [[2], [0]]]],
    ff: [[1, [[43]]]],
    fi: [[1, [[7, 8]]]],
    fil: [
        [
            1,
            [
                [8, 35],
                [8, 36],
                [37, 38]
            ]
        ]
    ],
    fo: [[1, [[0]]]],
    fr: [
        [1, [[43]]],
        [4, [[31, 32, 33, 8], [34]]]
    ],
    fur: [[1, [[0]]]],
    fy: [[1, [[7, 8]]]],
    ga: [
        [1, [[0]]],
        [2, [[4]]],
        [3, [[50]]],
        [4, [[51]]]
    ],
    gd: [
        [1, [[52]]],
        [2, [[53]]],
        [3, [[54]]]
    ],
    gl: [[1, [[7, 8]]]],
    gsw: [[1, [[0]]]],
    gu: [[1, [[2], [0]]]],
    guw: [[1, [[1]]]],
    gv: [
        [1, [[8, 23]]],
        [2, [[8, 55]]],
        [3, [[8, 56]]],
        [4, [[37]]]
    ],
    ha: [[1, [[0]]]],
    haw: [[1, [[0]]]],
    he: [
        [
            1,
            [
                [7, 8],
                [2, 37]
            ]
        ],
        [2, [[57, 8]]]
    ],
    hi: [[1, [[2], [0]]]],
    hnj: [],
    hr: [
        [
            1,
            [
                [8, 23, 24],
                [25, 26]
            ]
        ],
        [
            3,
            [
                [8, 27, 28],
                [29, 30]
            ]
        ]
    ],
    hsb: [
        [1, [[8, 44], [45]]],
        [2, [[8, 46], [47]]],
        [3, [[8, 48], [49]]]
    ],
    hu: [[1, [[0]]]],
    hy: [[1, [[43]]]],
    ia: [[1, [[7, 8]]]],
    id: [],
    ie: [[1, [[7, 8]]]],
    ig: [],
    ii: [],
    io: [[1, [[7, 8]]]],
    is: [
        [
            1,
            [
                [58, 23, 24],
                [59, 60]
            ]
        ]
    ],
    it: [
        [1, [[7, 8]]],
        [4, [[31, 32, 33, 8], [34]]]
    ],
    iu: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    ja: [],
    jbo: [],
    jgo: [[1, [[0]]]],
    jmc: [[1, [[0]]]],
    jv: [],
    jw: [],
    ka: [[1, [[0]]]],
    kab: [[1, [[43]]]],
    kaj: [[1, [[0]]]],
    kcg: [[1, [[0]]]],
    kde: [],
    kea: [],
    kk: [[1, [[0]]]],
    kkj: [[1, [[0]]]],
    kl: [[1, [[0]]]],
    km: [],
    kn: [[1, [[2], [0]]]],
    ko: [],
    kok: [[1, [[2], [0]]]],
    'kok-Latn': [[1, [[2], [0]]]],
    ks: [[1, [[0]]]],
    ksb: [[1, [[0]]]],
    ksh: [
        [0, [[3]]],
        [1, [[0]]]
    ],
    ku: [[1, [[0]]]],
    kw: [
        [0, [[3]]],
        [1, [[0]]],
        [2, [[61], [62, 63], [21, 64]]],
        [3, [[65]]],
        [4, [[66, 67]]]
    ],
    ky: [[1, [[0]]]],
    lag: [
        [0, [[3]]],
        [1, [[43, 21]]]
    ],
    lb: [[1, [[0]]]],
    lg: [[1, [[0]]]],
    lij: [[1, [[7, 8]]]],
    lkt: [],
    lld: [
        [1, [[7, 8]]],
        [4, [[31, 32, 33, 8], [34]]]
    ],
    ln: [[1, [[1]]]],
    lo: [],
    lt: [
        [1, [[9, 68]]],
        [3, [[69, 68]]],
        [4, [[70]]]
    ],
    lv: [
        [0, [[13], [71], [72, 73]]],
        [
            1,
            [
                [9, 10],
                [72, 25, 26],
                [74, 25]
            ]
        ]
    ],
    mas: [[1, [[0]]]],
    mg: [[1, [[1]]]],
    mgo: [[1, [[0]]]],
    mk: [
        [
            1,
            [
                [8, 23, 24],
                [25, 26]
            ]
        ]
    ],
    ml: [[1, [[0]]]],
    mn: [[1, [[0]]]],
    mo: [
        [1, [[7, 8]]],
        [3, [[37], [3], [66, 75]]]
    ],
    mr: [[1, [[0]]]],
    ms: [],
    mt: [
        [1, [[0]]],
        [2, [[4]]],
        [3, [[3], [5]]],
        [4, [[71]]]
    ],
    my: [],
    nah: [[1, [[0]]]],
    naq: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    nb: [[1, [[0]]]],
    nd: [[1, [[0]]]],
    ne: [[1, [[0]]]],
    nl: [[1, [[7, 8]]]],
    nn: [[1, [[0]]]],
    nnh: [[1, [[0]]]],
    no: [[1, [[0]]]],
    nqo: [],
    nr: [[1, [[0]]]],
    nso: [[1, [[1]]]],
    ny: [[1, [[0]]]],
    nyn: [[1, [[0]]]],
    om: [[1, [[0]]]],
    or: [[1, [[0]]]],
    os: [[1, [[0]]]],
    osa: [],
    pa: [[1, [[1]]]],
    pap: [[1, [[0]]]],
    pcm: [[1, [[2], [0]]]],
    pl: [
        [1, [[7, 8]]],
        [3, [[8, 27, 28]]],
        [
            4,
            [
                [8, 76, 77],
                [8, 78],
                [8, 79]
            ]
        ]
    ],
    prg: [
        [0, [[13], [71], [72, 73]]],
        [
            1,
            [
                [9, 10],
                [72, 25, 26],
                [74, 25]
            ]
        ]
    ],
    ps: [[1, [[0]]]],
    pt: [
        [1, [[80]]],
        [4, [[31, 32, 33, 8], [34]]]
    ],
    'pt-PT': [
        [1, [[7, 8]]],
        [4, [[31, 32, 33, 8], [34]]]
    ],
    rm: [[1, [[0]]]],
    ro: [
        [1, [[7, 8]]],
        [3, [[37], [3], [66, 75]]]
    ],
    rof: [[1, [[0]]]],
    ru: [
        [1, [[8, 23, 24]]],
        [3, [[8, 27, 28]]],
        [
            4,
            [
                [8, 81],
                [8, 78],
                [8, 82]
            ]
        ]
    ],
    rwk: [[1, [[0]]]],
    sah: [],
    saq: [[1, [[0]]]],
    sat: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    sc: [[1, [[7, 8]]]],
    scn: [
        [1, [[7, 8]]],
        [4, [[31, 32, 33, 8], [34]]]
    ],
    sd: [[1, [[0]]]],
    sdh: [[1, [[0]]]],
    se: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    seh: [[1, [[0]]]],
    ses: [],
    sg: [],
    sgs: [
        [1, [[9, 10]]],
        [2, [[4]]],
        [3, [[83, 69, 68]]],
        [4, [[70]]]
    ],
    sh: [
        [
            1,
            [
                [8, 23, 24],
                [25, 26]
            ]
        ],
        [
            3,
            [
                [8, 27, 28],
                [29, 30]
            ]
        ]
    ],
    shi: [
        [1, [[2], [0]]],
        [3, [[84]]]
    ],
    si: [[1, [[85], [2, 86]]]],
    sk: [
        [1, [[7, 8]]],
        [3, [[39, 8]]],
        [4, [[37]]]
    ],
    sl: [
        [1, [[8, 44]]],
        [2, [[8, 46]]],
        [3, [[8, 48], [37]]]
    ],
    sma: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    smi: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    smj: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    smn: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    sms: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    sn: [[1, [[0]]]],
    so: [[1, [[0]]]],
    sq: [[1, [[0]]]],
    sr: [
        [
            1,
            [
                [8, 23, 24],
                [25, 26]
            ]
        ],
        [
            3,
            [
                [8, 27, 28],
                [29, 30]
            ]
        ]
    ],
    ss: [[1, [[0]]]],
    ssy: [[1, [[0]]]],
    st: [[1, [[0]]]],
    su: [],
    sv: [[1, [[7, 8]]]],
    sw: [[1, [[7, 8]]]],
    syr: [[1, [[0]]]],
    ta: [[1, [[0]]]],
    te: [[1, [[0]]]],
    teo: [[1, [[0]]]],
    th: [],
    ti: [[1, [[1]]]],
    tig: [[1, [[0]]]],
    tk: [[1, [[0]]]],
    tl: [
        [
            1,
            [
                [8, 35],
                [8, 36],
                [37, 38]
            ]
        ]
    ],
    tn: [[1, [[0]]]],
    to: [],
    tpi: [],
    tr: [[1, [[0]]]],
    ts: [[1, [[0]]]],
    tzm: [[1, [[1], [87]]]],
    ug: [[1, [[0]]]],
    uk: [
        [1, [[8, 23, 24]]],
        [3, [[8, 27, 28]]],
        [
            4,
            [
                [8, 81],
                [8, 78],
                [8, 82]
            ]
        ]
    ],
    und: [],
    ur: [[1, [[7, 8]]]],
    uz: [[1, [[0]]]],
    ve: [[1, [[0]]]],
    vec: [
        [1, [[7, 8]]],
        [4, [[31, 32, 33, 8], [34]]]
    ],
    vi: [],
    vo: [[1, [[0]]]],
    vun: [[1, [[0]]]],
    wa: [[1, [[1]]]],
    wae: [[1, [[0]]]],
    wo: [],
    xh: [[1, [[0]]]],
    xog: [[1, [[0]]]],
    yi: [[1, [[7, 8]]]],
    yo: [],
    yue: [],
    zh: [],
    zu: [[1, [[2], [0]]]]
};
export var ordinalRules = {
    af: [],
    am: [],
    an: [],
    ar: [],
    as: [
        [1, [[88]]],
        [2, [[89]]],
        [3, [[90]]],
        [4, [[41]]]
    ],
    ast: [],
    az: [
        [1, [[91], [92]]],
        [3, [[93], [94]]],
        [4, [[2], [95], [96]]]
    ],
    bal: [[1, [[0]]]],
    be: [[3, [[97, 98]]]],
    bg: [],
    blo: [
        [0, [[2]]],
        [1, [[7]]],
        [3, [[99]]]
    ],
    bn: [
        [1, [[88]]],
        [2, [[89]]],
        [3, [[90]]],
        [4, [[41]]]
    ],
    bs: [],
    ca: [
        [1, [[100]]],
        [2, [[4]]],
        [3, [[90]]]
    ],
    ce: [],
    cs: [],
    cv: [],
    cy: [
        [0, [[101]]],
        [1, [[0]]],
        [2, [[4]]],
        [3, [[102]]],
        [4, [[103]]]
    ],
    da: [],
    de: [],
    dsb: [],
    el: [],
    en: [
        [1, [[9, 10]]],
        [2, [[17, 104]]],
        [3, [[105, 106]]]
    ],
    es: [],
    et: [],
    eu: [],
    fa: [],
    fi: [],
    fil: [[1, [[0]]]],
    fr: [[1, [[0]]]],
    fy: [],
    ga: [[1, [[0]]]],
    gd: [
        [1, [[52]]],
        [2, [[53]]],
        [3, [[107]]]
    ],
    gl: [],
    gsw: [],
    gu: [
        [1, [[0]]],
        [2, [[89]]],
        [3, [[90]]],
        [4, [[41]]]
    ],
    he: [],
    hi: [
        [1, [[0]]],
        [2, [[89]]],
        [3, [[90]]],
        [4, [[41]]]
    ],
    hr: [],
    hsb: [],
    hu: [[1, [[108]]]],
    hy: [[1, [[0]]]],
    ia: [],
    id: [],
    ie: [],
    is: [],
    it: [[4, [[109]]]],
    ja: [],
    ka: [
        [1, [[7]]],
        [4, [[2], [110]]]
    ],
    kk: [[4, [[111], [112], [13, 21]]]],
    km: [],
    kn: [],
    ko: [],
    kok: [
        [1, [[0]]],
        [2, [[89]]],
        [3, [[90]]]
    ],
    'kok-Latn': [
        [1, [[0]]],
        [2, [[89]]],
        [3, [[90]]]
    ],
    kw: [
        [1, [[113], [114]]],
        [4, [[115], [116]]]
    ],
    ky: [],
    lij: [[4, [[117]]]],
    lld: [[4, [[109]]]],
    lo: [[1, [[0]]]],
    lt: [],
    lv: [],
    mk: [
        [1, [[23, 24]]],
        [2, [[55, 118]]],
        [4, [[119, 120]]]
    ],
    ml: [],
    mn: [],
    mo: [[1, [[0]]]],
    mr: [
        [1, [[0]]],
        [2, [[89]]],
        [3, [[90]]]
    ],
    ms: [[1, [[0]]]],
    my: [],
    nb: [],
    ne: [[1, [[113]]]],
    nl: [],
    no: [],
    or: [
        [1, [[121]]],
        [2, [[89]]],
        [3, [[90]]],
        [4, [[41]]]
    ],
    pa: [],
    pl: [],
    prg: [],
    ps: [],
    pt: [],
    ro: [[1, [[0]]]],
    ru: [],
    sc: [[4, [[109]]]],
    scn: [[4, [[117]]]],
    sd: [],
    sh: [],
    si: [],
    sk: [],
    sl: [],
    sq: [
        [1, [[0]]],
        [4, [[122, 123]]]
    ],
    sr: [],
    sv: [[1, [[124, 125]]]],
    sw: [],
    ta: [],
    te: [],
    th: [],
    tk: [[3, [[126], [127]]]],
    tl: [[1, [[0]]]],
    tpi: [],
    tr: [],
    uk: [[3, [[105, 106]]]],
    und: [],
    ur: [],
    uz: [],
    vec: [[4, [[109]]]],
    vi: [[1, [[0]]]],
    yue: [],
    zh: [],
    zu: []
};
export var expressions = [
    ['n', 0, 1, [1]],
    ['n', 0, 1, [[0, 1]]],
    ['i', 0, 1, [0]],
    ['n', 0, 1, [0]],
    ['n', 0, 1, [2]],
    ['n', 100, 1, [[3, 10]]],
    ['n', 100, 1, [[11, 99]]],
    ['i', 0, 1, [1]],
    ['v', 0, 1, [0]],
    ['n', 10, 1, [1]],
    ['n', 100, 0, [11]],
    ['n', 10, 1, [[2, 4]]],
    ['n', 100, 0, [[12, 14]]],
    ['n', 10, 1, [0]],
    ['n', 10, 1, [[5, 9]]],
    ['n', 100, 1, [[11, 14]]],
    ['n', 100, 0, [11, 71, 91]],
    ['n', 10, 1, [2]],
    ['n', 100, 0, [12, 72, 92]],
    ['n', 10, 1, [[3, 4], 9]],
    [
        'n',
        100,
        0,
        [
            [10, 19],
            [70, 79],
            [90, 99]
        ]
    ],
    ['n', 0, 0, [0]],
    ['n', 1000000, 1, [0]],
    ['i', 10, 1, [1]],
    ['i', 100, 0, [11]],
    ['f', 10, 1, [1]],
    ['f', 100, 0, [11]],
    ['i', 10, 1, [[2, 4]]],
    ['i', 100, 0, [[12, 14]]],
    ['f', 10, 1, [[2, 4]]],
    ['f', 100, 0, [[12, 14]]],
    ['c', 0, 1, [0]],
    ['i', 0, 0, [0]],
    ['i', 1000000, 1, [0]],
    ['c', 0, 0, [[0, 5]]],
    ['i', 0, 1, [1, 2, 3]],
    ['i', 10, 0, [4, 6, 9]],
    ['v', 0, 0, [0]],
    ['f', 10, 0, [4, 6, 9]],
    ['i', 0, 1, [[2, 4]]],
    ['n', 0, 1, [3]],
    ['n', 0, 1, [6]],
    ['t', 0, 0, [0]],
    ['i', 0, 1, [0, 1]],
    ['i', 100, 1, [1]],
    ['f', 100, 1, [1]],
    ['i', 100, 1, [2]],
    ['f', 100, 1, [2]],
    ['i', 100, 1, [[3, 4]]],
    ['f', 100, 1, [[3, 4]]],
    ['n', 0, 1, [[3, 6]]],
    ['n', 0, 1, [[7, 10]]],
    ['n', 0, 1, [1, 11]],
    ['n', 0, 1, [2, 12]],
    [
        'n',
        0,
        1,
        [
            [3, 10],
            [13, 19]
        ]
    ],
    ['i', 10, 1, [2]],
    ['i', 100, 1, [0, 20, 40, 60, 80]],
    ['i', 0, 1, [2]],
    ['t', 0, 1, [0]],
    ['t', 10, 1, [1]],
    ['t', 100, 0, [11]],
    ['n', 100, 1, [2, 22, 42, 62, 82]],
    ['n', 1000, 1, [0]],
    ['n', 100000, 1, [[1000, 20000], 40000, 60000, 80000]],
    ['n', 1000000, 1, [100000]],
    ['n', 100, 1, [3, 23, 43, 63, 83]],
    ['n', 0, 0, [1]],
    ['n', 100, 1, [1, 21, 41, 61, 81]],
    ['n', 100, 0, [[11, 19]]],
    ['n', 10, 1, [[2, 9]]],
    ['f', 0, 0, [0]],
    ['n', 100, 1, [[11, 19]]],
    ['v', 0, 1, [2]],
    ['f', 100, 1, [[11, 19]]],
    ['v', 0, 0, [2]],
    ['n', 100, 1, [[1, 19]]],
    ['i', 0, 0, [1]],
    ['i', 10, 1, [[0, 1]]],
    ['i', 10, 1, [[5, 9]]],
    ['i', 100, 1, [[12, 14]]],
    ['i', 0, 1, [[0, 1]]],
    ['i', 10, 1, [0]],
    ['i', 100, 1, [[11, 14]]],
    ['n', 0, 0, [2]],
    ['n', 0, 1, [[2, 10]]],
    ['n', 0, 1, [0, 1]],
    ['f', 0, 1, [1]],
    ['n', 0, 1, [[11, 99]]],
    ['n', 0, 1, [1, 5, 7, 8, 9, 10]],
    ['n', 0, 1, [2, 3]],
    ['n', 0, 1, [4]],
    ['i', 10, 1, [1, 2, 5, 7, 8]],
    ['i', 100, 1, [20, 50, 70, 80]],
    ['i', 10, 1, [3, 4]],
    ['i', 1000, 1, [100, 200, 300, 400, 500, 600, 700, 800, 900]],
    ['i', 10, 1, [6]],
    ['i', 100, 1, [40, 60, 90]],
    ['n', 10, 1, [2, 3]],
    ['n', 100, 0, [12, 13]],
    ['i', 0, 1, [2, 3, 4, 5, 6]],
    ['n', 0, 1, [1, 3]],
    ['n', 0, 1, [0, 7, 8, 9]],
    ['n', 0, 1, [3, 4]],
    ['n', 0, 1, [5, 6]],
    ['n', 100, 0, [12]],
    ['n', 10, 1, [3]],
    ['n', 100, 0, [13]],
    ['n', 0, 1, [3, 13]],
    ['n', 0, 1, [1, 5]],
    ['n', 0, 1, [11, 8, 80, 800]],
    ['i', 100, 1, [[2, 20], 40, 60, 80]],
    ['n', 10, 1, [6]],
    ['n', 10, 1, [9]],
    ['n', 0, 1, [[1, 4]]],
    [
        'n',
        100,
        1,
        [
            [1, 4],
            [21, 24],
            [41, 44],
            [61, 64],
            [81, 84]
        ]
    ],
    ['n', 0, 1, [5]],
    ['n', 100, 1, [5]],
    ['n', 0, 1, [11, 8, [80, 89], [800, 899]]],
    ['i', 100, 0, [12]],
    ['i', 10, 1, [7, 8]],
    ['i', 100, 0, [17, 18]],
    ['n', 0, 1, [1, 5, [7, 9]]],
    ['n', 10, 1, [4]],
    ['n', 100, 0, [14]],
    ['n', 10, 1, [1, 2]],
    ['n', 100, 0, [11, 12]],
    ['n', 10, 1, [6, 9]],
    ['n', 0, 1, [10]]
];
//# sourceMappingURL=autogen.rules.js.map